import { useContext } from 'react';

import { DialogContext } from '../components';

export const useDialog = () => {
  return useContext(DialogContext);
};
